export const menulists = [
  {
    id: 1,
    path: "/",
    link: "home",
  },
  // {
  //   id: 2,
  //   path: "/product",
  //   link: "product",
  // },
  // {
  //   id: 3,
  //   path: "/blog",
  //   link: "Blog",
  // },
  // {
  //   id: 4,
  //   path: "/about",
  //   link: "about",
  // },
  // {
  //   id: 5,
  //   path: "/services",
  //   link: "Services",
  // },
  // {
  //   id: 6,
  //   path: "/contact",
  //   link: "Contact",
  // },
];

export const categorylists = [
  {
    id: 1,
    image: "../images/category/c1.png",
    title: "watches",
  },
  {
    id: 2,
    image: "../images/category/c2.png",
    title: "electronics",
  },
  {
    id: 3,
    image: "../images/category/c3.png",
    title: "sports",
  },
  {
    id: 4,
    image: "../images/category/c4.png",
    title: "real estate",
  },
  {
    id: 5,
    image: "../images/category/c5.png",
    title: "vehicle",
  },
  {
    id: 6,
    image: "../images/category/c6.png",
    title: "jewelry",
  },
  {
    id: 7,
    image: "../images/category/c7.png",
    title: "clothes",
  },
];

export const productlists = [
  {
    id: 1,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/nuron-art-demo-image-7-768x768.png",
    title: "Blown Glass Creations for Every Occasion",
    bprice: 853,
    price: 5000,
    catgeory: "Arts",
  },
  {
    id: 2,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/nuron-art-demo-image-8-390x532.png",
    title: "Capturing Nature’s Beauty",
    bprice: 452,
    price: 1420,
    catgeory: "Arts",
  },
  {
    id: 3,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/nuron-art-demo-image-1-390x532.png",
    title: "Ceramic Tea Sets with a Twist",
    bprice: 105,
    price: 100,
    catgeory: "Arts",
  },
  {
    id: 4,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-01-600x600.jpg",
    title: "Vintage Motorcycles and Scooters",
    bprice: 40000,
    price: 50000,
    catgeory: "Automotive",
  },
  {
    id: 5,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-02-600x600.jpg",
    title: "Off-Road Adventure Seekers",
    bprice: 4000,
    price: 8000,
    catgeory: "Automotive",
  },
  {
    id: 6,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-04-600x600.jpg",
    title: "Rare Exotics and Supercars",
    bprice: 40000,
    price: 80000,
    catgeory: "Automotive",
  },
  {
    id: 6,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/books_demo_product_07-600x600.jpg",
    title: "Rare Exotics and Supercars",
    bprice: 400,
    price: 800,
    catgeory: "Romantic Escapes",
  },
  {
    id: 7,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/books_demo_product_02-600x600.jpg",
    title: "Epic Fantasy Chronicles",
    bprice: 200,
    price: 800,
    catgeory: "Romantic Escapes",
  },
  {
    id: 8,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/books_demo_product_09-600x600.jpg",
    title: "Graphic Non-Fiction",
    bprice: 200,
    price: 800,
    catgeory: "Romantic Escapes",
  },
  {
    id: 9,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/coin-auction-demo-product-10-768x768.jpg",
    title: "Coin Hyundai Sonata",
    bprice: 853,
    price: 5000,
    catgeory: "Arts",
  },
  {
    id: 10,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/coin-auction-demo-product-07-768x768.jpg",
    title: "2018 Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 11,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/lab-product-05-768x768.jpg",
    title: "2018 Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://netstorm-react.theme-land.com/img/auction_4.jpg",
    title: "2018 Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://netstorm-react.theme-land.com/img/auction_5.jpg",
    title: "2018 Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://netstorm-react.theme-land.com/img/auction_6.jpg",
    title: "2018 Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://netstorm-react.theme-land.com/img/auction_7.jpg",
    title: "2018 Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://netstorm-react.theme-land.com/img/auction_8.jpg",
    title: "2018 Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://bidout-wp.b-cdn.net/wp-content/uploads/2022/10/Image-10.jpg",
    title: "2018 Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/antiques-demo-product-09-768x768.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://bidpro.webdevia.com/wp-content/uploads/2018/12/photo-1596568359553-a56de6970068-600x414.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://bidpro.webdevia.com/wp-content/uploads/2018/05/florian-klauer-mk7D-4UCfmg-unsplash-600x414.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://bidpro.webdevia.com/wp-content/uploads/2018/05/igor-karimov-59MGmlUiqwA-unsplash-600x414.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://bidpro.webdevia.com/real-estate-auction-marketplace/wp-content/uploads/sites/5/2022/03/home-9-1-450x338.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/antiques-demo-product-10-768x768.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://jew-theme.myshopify.com/cdn/shop/files/Rectangle_144.png?v=1703498789&width=1500",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://themesflat.co/html/open9/assets/images/box-item/card-item-05.jpg",
    title: "2018 Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://themesflat.co/html/open9/assets/images/box-item/card-item-06.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://themesflat.co/html/open9/assets/images/box-item/card-item-07.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://themesflat.co/html/open9/assets/images/box-item/card-item-08.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://themesflat.co/html/open9/assets/images/box-item/card-item-01.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://themesflat.co/html/open9/assets/images/box-item/card-item-02.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://themesflat.co/html/open9/assets/images/box-item/card-item-03.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
  {
    id: 1,
    image: "https://themesflat.co/html/open9/assets/images/box-item/card-item-04.jpg",
    title: "Watch Hyundai Sonata",
    bprice: 853,
    price: 5000,
  },
];

export const processList = [
  {
    id: "01",
    title: "Sign up",
    desc: "Sign your car up via our contact form or via the WhatsApp chat on the website. Send us a couple of pictures of the car that you want to put up for auction.",
    cover: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/shape-7.png",
  },
  {
    id: "02",
    title: "Auction goes online",
    desc: "As soon as we collect enough cars for the auction (we strive for 25 to 40 cars per auction), the auction will show up on the website.",
    cover: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/auction.png",
  },
  {
    id: "03",
    title: "Closing auction",
    desc: "After the viewing day(s) the auction is still a few days open for new bids. We evaluate the highest bid after the closing of an auction.",
    cover: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/auction-2.png",
  },
  {
    id: "04",
    title: "The last steps",
    desc: "After the car is sold to the highest bidder, all the cars will be collected by the buyers on a determined date.",
    cover: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/auction-3.png",
  },
];

export const topSellerList = [
  {
    id: 1,
    title: "William",
    profile: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/client-5-1.png",
    amount: "100",
  },
  {
    id: 2,
    title: "Orko",
    profile: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/client-6.png",
    amount: "200",
  },
  {
    id: 3,
    title: "Nipa",
    profile: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/client-3.png",
    amount: "300",
  },
  {
    id: 4,
    title: "Joseph",
    profile: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/client-2-2.png",
    amount: "100",
  },
  {
    id: 5,
    title: "Isabella",
    profile: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/client-10-2.png",
    amount: "100",
  },
  {
    id: 6,
    title: "Emily",
    profile: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/client-15-1.png",
    amount: "100",
  },
  {
    id: 7,
    title: "Devmahbub",
    profile: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/client-8-3.png",
    amount: "100",
  },
  {
    id: 8,
    title: "Ava Garcia",
    profile: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/client-4-1.png",
    amount: "100",
  },
  {
    id: 9,
    title: "Amelia Harris",
    profile: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/client-13.png",
    amount: "100",
  },
  {
    id: 10,
    title: "Alexander",
    profile: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/01/client-8.png",
    amount: "100",
  },
];

export const trustList = [
  {
    id: 1,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor1.png",
  },
  {
    id: 2,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor3.png",
  },
  {
    id: 3,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor2.png",
  },
  {
    id: 4,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor4.png",
  },
  {
    id: 5,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor5.png",
  },
  {
    id: 6,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor6.png",
  },
  {
    id: 7,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor7.png",
  },
  {
    id: 8,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor8.png",
  },
  {
    id: 9,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor9.png",
  },
  {
    id: 10,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor1.png",
  },
  {
    id: 4,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor3.png",
  },
  {
    id: 5,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor8.png",
  },
  {
    id: 6,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor1.png",
  },
  {
    id: 7,
    profile: "https://bidout-react.vercel.app/images/bg/sponsor9.png",
  },
];

export const topList = [
  {
    id: 1,
    catgeory: "Luxury Vehicles",
    total: 7,
    img1: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-01-300x200.jpg",
    img2: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-07-150x150.jpg",
    img3: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-03-150x150.jpg",
    img4: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-08-150x150.jpg",
  },
  {
    id: 2,
    catgeory: "Classic",
    total: 10,
    img1: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-09-300x200.jpg",
    img2: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-01-150x150.jpg",
    img3: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-07-150x150.jpg",
    img4: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-03-150x150.jpg",
  },
  {
    id: 3,
    catgeory: "Muscle Machines",
    total: 8,
    img1: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-07-300x200.jpg",
    img2: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-03-150x150.jpg",
    img4: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-07-150x150.jpg",
    img3: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-01-150x150.jpg",
  },
  {
    id: 4,
    catgeory: "Automotive",
    total: 4,
    img3: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-05-300x200.jpg",
    img2: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-05-768x768.jpg",
    img4: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-07-150x150.jpg",
    img1: "https://rainbowthemes.net/themes/nuron/wp-content/uploads/2023/09/automotive_product-04-768x768.jpg",
  },
];
